import React from "react";
import { useSelector } from "react-redux";
import { CopyTableToClipboardButton, CopyToClipboardButton, RedressButton, UpdateSentenceTypeButton } from ".";
import { hasUpdateRights } from "../../../../../../utils/utils";
import { DOCUMENT_STATUSES } from "../../../../../../constants/constants";

export default function ActionSublayer({ className = "", hoveredBlock, onUpdateHoveredArea }) {
	const roles = useSelector(({ srDocument }) => srDocument.roles);
	const isArchived = useSelector(({ srDocument }) => srDocument.status === DOCUMENT_STATUSES.ARCHIVED);
	return (
		<div className={className}>
			<CopyTableToClipboardButton hoveredBlock={hoveredBlock} />
			<CopyToClipboardButton hoveredBlock={hoveredBlock} />
			{hasUpdateRights(roles) && !isArchived && (
				<>
					<RedressButton hoveredBlock={hoveredBlock} />
					<UpdateSentenceTypeButton hoveredBlock={hoveredBlock} onUpdateHoveredArea={onUpdateHoveredArea} />
				</>
			)}
		</div>
	);
}
